/* eslint-disable import/no-cycle */
import _ from 'lodash';
import moment from 'moment';
import { sendCloudWatchLogs, sendCloudWatchAlert } from '../utils/applicationError';
import { getOrderStatusLabel } from '../utils/orderUtils';
import { mooveOrderToTakeAway, mooveOrderToPastOrder, getCompletedOrders, lunchDelivery, acceptDelivery } from '../apis/backend';
import { SET_FINISH_ORDERS, REFUND_ORDER } from './types';
import { ORDER_COMPLETED, ORDER_PAST, ORDER_CANCELED, ERROR_GET_PAST_ORDERS } from '../constants';
import { openErrorModal } from './modalAction';

export const getFinishedOrders = (
  shopId,
  dateRange,
  showSpinner = false,
  isAllShops
) => async dispatch => {
  try {
    showSpinner && dispatch({ type: SET_FINISH_ORDERS, payload: null });
    const startDate = moment(dateRange.startDate).startOf('day').utcOffset(0, true).toISOString();
    const endDate = moment(dateRange.endDate).endOf('day').utcOffset(0, true).toISOString();
    const completedOrders = await getCompletedOrders(
      isAllShops ? null : shopId,
      'dateCompleted',
      null,
      startDate,
      endDate,
    );
    const allOrders = [];
    _.map(completedOrders, order => {
      if (moment(order.date)) {
        const { status, cancellation = {} } = order;
        const { cancelReason } = cancellation;
        order.statusLabel = getOrderStatusLabel(
          status === ORDER_COMPLETED ? ORDER_PAST : ORDER_CANCELED,
          cancelReason,
          status
        );
        allOrders.push(order);
      }
    });
    dispatch({ type: SET_FINISH_ORDERS, payload: allOrders });
  } catch (error) {
    sendCloudWatchAlert(`Cannot get terminated orders ${error}`);
    dispatch(openErrorModal(ERROR_GET_PAST_ORDERS));
    dispatch({ type: SET_FINISH_ORDERS, payload: [] });
  }
};

export const refundOrder = order => async dispatch => {
  dispatch({ type: REFUND_ORDER, payload: order });
};
export const handleOrderReadyOnFirebase = order => async () => {
  await mooveOrderToTakeAway(order);
  sendCloudWatchLogs('Order ready for take away', order);
};

export const handleTakesOrderOnFirebase = order => async () => {
  await mooveOrderToPastOrder(order);
  sendCloudWatchLogs('Order successfully validated', order);
};
export const handleLunchDeliveryOnFirebase = (order) => async () => {
  await lunchDelivery(order);
  sendCloudWatchLogs('lunch delivery', order);
};
export const handleAcceptDeliveryOnFirebase = (order) => async () => {
  await acceptDelivery(order);
  sendCloudWatchLogs('accept delivery', order);
};
